<template>
  <!-- 对比分析 -->
  <el-row class="contrastive flex-grow-1" type="flex" :gutter="12">
    <!-- 右側 -->
    <el-col :span="24" class="d-flex flex-column align-items-stretch">
      <!-- 條件查詢 -->
      <div class="selector-container section-container d-flex align-items-center"
       :class="{'dark':skinType}">
         <SectionTitle title="对比分析" ></SectionTitle>
        <el-form
          :inline="true"
          style="text-align: left"
          size="small"
        >
          <period-date-selector
            :isDateSelector="
              selectNode &&
              selectNode.oType !== 'jx' &&
              selectNode.oType !== 'cx'
            "
            @startEndDate="startEndDateListener"
          ></period-date-selector>
          <el-form-item label="">
            <el-radio-group v-model="compareDateType" size="small">
              <el-radio-button
                v-for="item in options"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button  @click="exportTable">导出</el-button>
          </el-form-item>
        </el-form>
        <el-button style="margin-left:auto;" size="small"
        type="primary" circle icon="iconfont  iconfanhui"
        v-on:click="$router.go(-1)"></el-button>
      </div>
      <el-table  size="small"
        class="energy-table none-height flex-grow-1 d-flex flex-column"
        :data="tableData"
        stripe
                height="0"
        style="width: 100%"
        ref="table"
        :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
        :class="{'dark':skinType}"
      >
        <el-table-column prop="PointName" label="监测点" min-width="120"> </el-table-column>
        <el-table-column label="基准日期">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              scope.row.BaseDate.split(" ")[0]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="BasePowerConsumption" label="基准电量(kWh)">
        </el-table-column>
        <el-table-column
          prop="ContrastivePowerConsumption"
          label="对比电量(kWh)"
        >
        </el-table-column>
        <el-table-column prop="Rise" label="增电量(kWh)"> </el-table-column>
        <el-table-column label="增长率(%)">
          <template slot-scope="scope">
            <span
              >{{
                scope.row.RateOfRise ? scope.row.RateOfRise.toFixed(2) : "--"
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="d-flex section-container" style="padding:1rem;" :class="{'dark':skinType}">
        <el-pagination
          v-if="pageInfo.total"
          style="margin-left: auto"
          :class="{'text-white':skinType}"
          background
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          :current-page.sync="pageIndex"
        >
        </el-pagination>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { contrastiveAnalysis } from '@/api/statistic/statistic';
import PeriodDateSelector from '@/components/energy-analysis/components/period-date-selector.vue';
import { exportExcel } from '@/utils/utils';

export default {
  name: 'contrastive',
  components: {
    PeriodDateSelector,
    SectionTitle,
  },
  data() {
    return {
      idstr: '',
      startEndDate: null,
      compareDateType: 0,
      pageIndex: 1,
      pageInfo: {
        index: 1,
        size: 10,
        total: 0,
      },
      selectNode: null,
      tableData: [],
      options: [
        {
          label: '上日',
          value: 1,
        },
        {
          label: '上周',
          value: 2,
        },
        {
          label: '上月',
          value: 3,
        },
        {
          label: '上年',
          value: 4,
        },
      ],
      nodeList: [],
    };
  },
  watch: {
    pageIndex() {
      this.requestConstrativeList();
    },
    startEndDate() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestConstrativeList();
    },
    compareDateType() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestConstrativeList();
    },
  },
  mounted() {
    this.idstr = this.$route.params.id;
    console.log(this.$route.params.id);
    this.requestConstrativeList();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    nodeListChangeListener(list) {
      this.nodeList = list;
    },
    currentChangeListener(no) {
      this.pageIndex = no;
    },
    startEndDateListener(datePeriod) {
      this.startEndDate = datePeriod;
    },
    requestConstrativeList() {
      if (this.startEndDate === null) {
        return;
      }
      if (!this.idstr) {
        return;
      }
      contrastiveAnalysis({
        oType: 'hb',
        oIDstr: this.idstr,
        cType: this.compareDateType,
        BeginDate: this.startEndDate.start,
        EndDate: this.startEndDate.end,
        page: this.pageIndex,
        rows: this.pageInfo.size,
      })
        .then((res) => {
          if (res !== null && res.list) {
            this.tableData = res.list;
            this.pageInfo.total = res.total;
            return;
          }
          this.tableData = res || [];
        })
        .catch(() => {
          this.tableData = [];
        });
    },
    selectNodeListener(node) {
      this.pageIndex = 1;
      this.selectNode = node;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onSubmit() {
      this.requestConstrativeList();
    },
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row';
      }
      if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
  },
};
</script>
<style scoped>
.energy-table.el-table .warning-row {
  background: oldlace;
}

.energy-table.el-table .success-row {
  background: #f0f9eb;
}
.breadcrumbs-contain {
  background-color: white;
  padding: 1rem;
  margin-bottom: 1rem;
}
</style>
